export default __webpack_public_path__ + "static/data-more-about-img2--mobile-f1c50063a93eef3bd5e4af0d5a845ae3.png";